export abstract class CompareParameters {
  public static compare(list: any[]) {
    let newList: any[] = [];

    list.forEach((obj, objIndex) => {
      const tmpArray = [] as any;

      obj.values.forEach((item: any) => {
        for (let i = 0; i < item.compareValues.length; i++) {
          for (let j = i + 1; j < item.compareValues.length; j++) {
            if (item.compareValues[i] !== item.compareValues[j]) {
              const dict = { key: item.key, compareValues: item.compareValues };
              tmpArray.push(dict);
            }
          }
        }
      });

      newList[objIndex] = { group: list[objIndex].group, values: tmpArray };
    });

    newList = newList.filter((item) => item.values.length > 0);

    return newList;
  }
}
